import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { graphql, withApollo } from 'react-apollo';

import WithAuthService from '@/hocs/withAuthService';

import { mutatorRoutePerform } from '../../utils/mutatorRouteHelpers';
import { trackEventUnsaved } from '../../utils/tracking';
import { UnsaveEventMutation } from '../../state/services/gql/user';

import LoadingEllipsis from '../../components/LoadingEllipsis';
import Meta from '../../components/Meta';
import getUrl from '@/routes/routes/helpers/getUrl';

import { EventTrackingParamsQuery } from '../../state/services/gql/event';
import { logCustomEvent, BrazeCustomEvents } from '../../state/services/braze';

/**
 * Unsave Event Page component.
 * This page performs an unsave event mutation (on mount) and redirects to the saved events page,
 * used as a return URL destination when attempting to unsave an event when unauthenticated.
 */
export class UnsaveEventPageContainer extends PureComponent {
  async componentDidMount() {
    // Await Braze log, then make mutation
    await this.logBrazeEventUnsavedCustomEvent(this.props);
    mutatorRoutePerform(this.props, trackEventUnsaved, { id: 'id' });
  }

  getBrazeEventData = ({ id, title, organiser, races, startDate }) => {
    const organiserData =
      organiser && organiser.title ? { organiser_title: organiser.title } : {};
    return {
      event_id: id,
      event_name: title,
      event_start_date: startDate,
      event_booking_enabled: !!(races && races.bookingEnabled),
      ...organiserData,
    };
  };

  async logBrazeEventUnsavedCustomEvent(props) {
    if (props.params && props.params.variables) {
      const parsedVariables = JSON.parse(props.params.variables);
      const eventId = parsedVariables.id;
      const { data } = await props.client.query({
        query: EventTrackingParamsQuery,
        variables: { eventId },
      });
      logCustomEvent(
        BrazeCustomEvents.EVENT_UNSAVED,
        this.getBrazeEventData(data),
      );
    }
  }

  render() {
    return (
      <div>
        <Meta robots="noindex" />
        <LoadingEllipsis />
      </div>
    );
  }
}

UnsaveEventPageContainer.propTypes = {
  /**
   * Router object.
   */
  router: PropTypes.shape({
    params: PropTypes.shape().isRequired,
    replace: PropTypes.func.isRequired,
  }).isRequired,
  /**
   * Unsave event mutation supplied by GQL wrapper.
   */
  /* eslint-disable react/no-unused-prop-types */
  mutate: PropTypes.func.isRequired,
};
const UnsaveEventPageContainerWithAuthService = WithAuthService(
  UnsaveEventPageContainer,
);

// Wrap with [GraphQL container](http://dev.apollodata.com/react/api-graphql.html)
export default graphql(UnsaveEventMutation)(
  withApollo(UnsaveEventPageContainerWithAuthService),
);
